(function() { module.exports = this["wp"]["blocks"]; }());